import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

let store = new Vuex.Store({
  state: {
    test: []
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js